import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import RouterLink from '../react_router/RouterLink';
import { SIGN_IN } from '../../private/routes';
import { Redirect, useRouteMatch } from 'react-router-dom';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '../forms/FormControl';
import Select from '@material-ui/core/Select';
import ErrorItem from './ErrorItem';
import AppCtx from '../../contexts/app_context';
import LocalStorage from '../../local_storage/LocalStorage';
import { v4 as uuidv4 } from 'uuid';
import MaterialContext from '../../contexts/material';
import { BLUE, GRAY, RED } from '../../style/colors';
import Banner from '../alerts/Banner';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 1),
  },
  subContainer: {
    paddingLeft: '5%',
    paddingRight: '5%',
  },
  banner:{

  }
}));



function getAllegianceText(side) {
  const obj = {
    btn: '',
    allegiance_helper: ''
  }
  switch (side) {
    case 'British':
      obj.btn = 'God Save the King'
      obj.allegiance_helper = 'Join the Cause of King and Country!'
      return obj
    case 'American':
      obj.btn = 'Join the Revolution'
      obj.allegiance_helper = 'Join the Cause of Freedom!'
      return obj
    default:
      obj.btn = 'Choose a Side'
      obj.allegiance_helper = 'Join the Cause of ...'
      return obj
  }
}

function useThemeChange() {
  const { setPrimaryTheme } = React.useContext(MaterialContext)
  return (allegiance) => {
    switch (allegiance) {
      case 'British':
        setPrimaryTheme(RED)
        break
      case 'American':
        setPrimaryTheme(BLUE)
        break
      default:
        setPrimaryTheme(GRAY)
        break
    }
  }
}

export default function SignIn(props) {
  const classes = useStyles();
  const match = useRouteMatch()
  const { signUpUser } = React.useContext(AppCtx)
  const [agent_name, setAgentName] = React.useState('')
  const [allegiance, setAllegiance] = React.useState('')
  const [age, setAge] = React.useState('youth (8-12)')
  const [error, setError] = React.useState('')
  const [redirect, setRedirect] = React.useState(null)
  const allegiance_text = getAllegianceText(allegiance)

  // allows us to change the theme, use in useEffect
  const themeChange = useThemeChange()
  React.useEffect(() => { themeChange(allegiance) }, [themeChange, allegiance])


  const submit = async e => {
    e.preventDefault()
    // TODO Add validation
    // validate, display the error message one at a time

    // validate agent name
    const other_users = LocalStorage.get('users')
    const user_names = other_users? Object.keys(other_users) : []
    if (user_names.find(x => x === agent_name)) {
      setError(`Agent Code Name "${agent_name}" already used on your device.`)
    } else {
      // reset
      setAgentName('')
      setError('')

      // register device if not already
      if (!LocalStorage.get('device_id')) {
        LocalStorage.set('device_id', uuidv4())
      }

      // create user
      const user_info = { age, agent_name, allegiance, auto_play_audio: false }
      signUpUser(user_info)

      // if props.redirect has a value route to given path
      props.redirect_path
        && setRedirect(<Redirect to={props.redirect_path} />)
    }
  }
  if (redirect) {
    return redirect
  }
  return (<>
    <Banner>
      Before you can play you must <strong>create a code name, join a side, 
      and select your age range.</strong>
    </Banner>
    <Container component="div" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign up
        </Typography>
        <form className={classes.form} onSubmit={submit}>
          <FormControl className={classes.formControl}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="agent_name"
              label="Create an Agent Name"
              type="text"
              id="agent_name"
              value={agent_name}
              onChange={(e) => setAgentName(e.target.value)}
            />
          </FormControl>
          <FormControl className={classes.formControl}>
            <InputLabel id="side_lable">Allegiance</InputLabel>
            <Select
              labelId="side_lable"
              id="side"
              value={allegiance}
              onChange={(e) => {

                setAllegiance(e.target.value)

              }}
            >
              <MenuItem value="American">American</MenuItem>
              <MenuItem value="British">British</MenuItem>
            </Select>
            <FormHelperText>{allegiance_text.allegiance_helper}</FormHelperText>
          </FormControl>

          <FormControl className={classes.formControl}>
            <InputLabel id="demo-simple-select-helper-label">Age</InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={age}
              onChange={(e) => setAge(e.target.value)}
            >
              <MenuItem value="youth (8-12)">Youth (8-12)</MenuItem>
              <MenuItem value="adolescent (13-16)">Adolescent (13-16)</MenuItem>
              <MenuItem value="adult (17+)">Adult (17+)</MenuItem>
            </Select>
            <FormHelperText>Your age is used to help find the right mission</FormHelperText>
          </FormControl>
          <br />
          <FormControl className={classes.formControl}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={!allegiance}
            >
              {allegiance_text.btn}
            </Button>
            <ErrorItem error={error} />
            <FormHelperText>
              We will never share your information with anyone else
            </FormHelperText>
          </FormControl>
          <Grid container>
            <Grid item>
              <RouterLink styled_link route href={`${match.path}${SIGN_IN}`}>
                Have an account? Sign In
              </RouterLink>
            </Grid>
          </Grid>
        </form>
      </div>
    </Container>
  </>);
}